/**
 * @Description 人口变化一览
 */

import { FC, useMemo } from 'react';
import styles from '../index.module.less';
import V2BarLineChart from '@/common/components/Charts/V2BarLineChart';
import { isUndef } from '@lhb/func';
import { Typography } from 'antd';
import React from 'react';


interface PopulationModuleProps {
  data: any;
  name: string;
}

const PopulationModule: FC<PopulationModuleProps> = React.memo(({ data, name }) => {
  const { years, populations, populationGrowthRates, title } = useMemo(() => {
    const years: any[] = [];
    const populations: any[] = [];
    const populationGrowthRates: any[] = [];
    let title: string = '';
    let startYear = '';
    let endYear = '';

    if (!data?.dataResponseList) { return { years, populations, populationGrowthRates, title, }; }

    data?.dataResponseList?.map((item, index) => {
      if (index === 0)startYear = item.year;
      if (index === data?.dataResponseList.length - 1) endYear = item.year;

      years.push(item.year);
      populations.push(isUndef(item.population) ? '' : item.population);
      populationGrowthRates.push(isUndef(item.populationGrowthRate) ? '' : item.populationGrowthRate);
    });

    title = `${startYear || ''}-${endYear || ''}${name || ''}人口变化一览`;

    return {
      years,
      populations,
      populationGrowthRates,
      title,
    };
  }, [data?.dataResponseList, name]);
  return (
    <div className={styles['module']}>
      {title
        ? <div className={styles.moduleChartWrap}>
          <div className={styles.moduleChartTitle}>
            <Typography.Text
              style={{ width: '100%' }}
              ellipsis={{ tooltip: title }}
            >
              {title}
            </Typography.Text>
          </div>
          <V2BarLineChart
            border
            title=''
            theme='green'
            xAxisData={years}
            seriesData={[{
              name: '常住人口',
              type: 'bar',
              yAxisIndex: 0,
              data: populations,
              unit: '万人'
            }, {
              name: '同比增长',
              type: 'line',
              unit: '%',
              yAxisIndex: 1,
              data: populationGrowthRates,
            }]}
            yAxisData={[
              // { max: Math.max(...populations), min: 0 },
              { scale: false },
              { axisLabel: { formatter: '{value}%' } },
            ]}
            config={{
              legend: {
                bottom: 4,
                top: 'auto',
                left: 'center',
                right: 'center',
                width: '100%',
              },
              grid: {
                bottom: 56,
              }
            }}
          />
        </div>
        : <></>}
    </div>
  );
});

export default PopulationModule;
